import { Box, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const AccountInfoWrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.borders.borderRadius.lg_8};
  background: ${({ theme }) => theme.palette.background.bgMenuPrimary};
`;

export const InfoContainer = styled(Box)<{ isMiniSidenav: boolean }>`
  display: flex;
  justify-content: ${({ isMiniSidenav }) =>
    isMiniSidenav ? "center" : "start"};
  gap: ${pxToRem(12)};
  border-radius: 8px;
  padding: 16px 12px;
  background: ${({ theme }) => theme.palette.background.bgMenuSecondary};
`;

export const InfoName = styled("span")`
  font-size: ${({ theme }) => theme.typography.size.md_16};
  font-weight: ${({ theme }) => theme.typography.fw_semibold_500};
  background: ${({ theme }) => theme.palette.background.bgMenuSecondary};

  // Responsive styles

  @media (max-width: 768px) {
    font-size: ${({ theme }) => theme.typography.size.sm_14};
    padding-left: 5px;
  }
`;

export const InfoCode = styled("span")`
  font-size: ${({ theme }) => theme.typography.size.xx_13};
  font-weight: ${({ theme }) => theme.typography.fw_semibold_500};
  color: ${({ theme }) => theme.palette.text.textLink};

  @media (max-width: 768px) {
    padding-left: 5px;
  }
`;

export const NotiContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px 8px 0 0;
  padding: 12px 13px;
  font-size: ${({ theme }) => theme.typography.size.sm_14};
  font-weight: ${({ theme }) => theme.typography.fw_semibold_500};
`;

export const CountCircle = styled(Box)`
  margin-left: 4px;
  border-radius: 100px;
  background: ${({ theme }) => theme.palette.background.bgNegative};
  font-size: ${({ theme }) => theme.typography.size.xs_12};
  color: ${({ theme }) => theme.palette.text.textWhite};
  font-weight: ${({ theme }) => theme.typography.fw_regular_400};
  width: 26px;
  height: 20px;
  text-align: center;
`;

export const NotificationWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: `${pxToRem(12)} ${pxToRem(13)}`,
}));

export const NotiAmount = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.bgNegative,
  color: "white",
  borderRadius: pxToRem(100),
  padding: `${pxToRem(2)} ${pxToRem(6)}`,
  paddingTop: pxToRem(1),
  fontSize: pxToRem(12),
}));

export const NotiIconArrow = styled(Box)`
  transform: rotate(180deg);
  svg {
    path {
      fill: ${({ theme }) => theme.palette.icon.icDefault};
    }
  }
`;

export const AvatarWrapper = styled(Box)`
  height: ${pxToRem(40)};
  width: ${pxToRem(40)};
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .camera-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    color: white;
    z-index: 2;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    border-radius: 50%;
    z-index: 1;
  }

  // &:hover .camera-icon {
  //   opacity: 1;
  // }

  // &:hover::after {
  //   opacity: 1;
  // }
`;
